import { render } from "./Project__Settings.vue?vue&type=template&id=67b14524"
import script from "./Project__Settings.vue?vue&type=script&lang=js"
export * from "./Project__Settings.vue?vue&type=script&lang=js"

import "./Project__Settings.vue?vue&type=style&index=0&id=67b14524&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__